import { fromJS } from 'immutable';
import { abortableFetch, getArcadeFetchOptions } from '@americanexpress/arcade-core';
import { addErrorToReport } from '@americanexpress/one-app-ducks';
import { STAMPS_SCAN_STATUS } from './constants';

export const apiGetUserStatus = () => async (dispatch, getState) => {
  const options = {
    url: `${getState().getIn(['config', 'arcadeApiUrl'])}/v1/passport/profile/status`,
    init: getArcadeFetchOptions(),
  };

  dispatch({
    type: 'modules/arcade-root/SET_PROFILE_STATUS_LOADING',
    payload: true,
  });

  abortableFetch({
    options,
    onResponse: (status, data) => {
      let action = {
        type: 'modules/arcade-root/SET_PROFILE_STATUS_API_ERROR',
        payload: true,
      };
      if (data && (status === 200 || status === 401 || status === 404)) {
        action = {
          type: 'modules/arcade-root/MERGE_VALUES',
          payload: fromJS({
            userStatus: data.status_code,
            canProfileRefresh: data.profile_refresh_indicator,
            isEnrollmentCapMet: data.is_enroll_cap_met,
            isProfileStatusApiError: false,
            isProfileStatusLoading: false,
          }),
        };
      }
      dispatch(action);
    },
    onException: (e, timestamp) => {
      dispatch({
        type: 'modules/arcade-root/SET_PROFILE_STATUS_API_ERROR',
        payload: true,
      });
      dispatch(addErrorToReport(e, {
        collectionMethod: 'apiGetUserStatus - Exception',
        moduleID: 'arcade-page-wrapper',
        trackingId: options.init.headers['x-amex-tracking-id'],
        ...timestamp,
      }));
    },
    dispatch,
  });
};

export const apiProfileRefresh = () => async (dispatch, getState) => {
  const options = {
    url: `${getState().getIn(['config', 'arcadeApiUrl'])}/v1/passport/profile`,
    init: {
      ...getArcadeFetchOptions(),
      method: 'PUT',
      body: JSON.stringify({ operation: 'update' }),
    },
  };

  await abortableFetch({
    options,
    onResponse: (status, data) => data && status === 200,
    onException: (e, timestamp) => {
      dispatch(addErrorToReport(e, {
        collectionMethod: 'apiProfileRefresh - Exception',
        moduleID: 'arcade-page-wrapper',
        trackingId: options.init.headers['x-amex-tracking-id'],
        ...timestamp,
      }));
    },
    dispatch,
  });
  dispatch({ type: 'modules/arcade-root/SET_PROFILE_REFRESH', payload: false });
};

export const apiGetPassportBanner = (setSurveyPromptStatus) => async (dispatch, getState) => {
  const options = {
    url: `${getState().getIn(['config', 'arcadeApiUrl'])}/v1/passport/banners`,
    init: getArcadeFetchOptions(),
  };

  return abortableFetch({
    options,
    onResponse: (status, data) => {
      const displayBanners = status === 200 && data?.status_code === 'success'
        ? data.display_banners
        : undefined;

      if (setSurveyPromptStatus) {
        setSurveyPromptStatus(displayBanners?.feedback?.display_indicator);
      }

      dispatch({
        type: 'modules/arcade-root/SET_SHOW_PUSH_NOTIFICATION_BANNER',
        payload: Boolean(displayBanners?.push_notification?.display_indicator),
      });

      return displayBanners;
    },
    onException: (e, timestamp) => {
      dispatch(addErrorToReport(e, {
        collectionMethod: 'apiGetPassportBanner - Exception',
        moduleID: 'arcade-page-wrapper',
        trackingId: options.init.headers['x-amex-tracking-id'],
        ...timestamp,
      }));
    },
    dispatch,
  });
};

let intervalId;
let statusCallCount = 0;
const resetInterval = () => {
  clearInterval(intervalId);
  intervalId = null;
  statusCallCount = 0;
};

export const apiPollStampsScanStatus = () => (dispatch, getState) => {
  if (!intervalId) {
    intervalId = setInterval(async () => {
      const options = {
        url: `${getState().getIn(['config', 'arcadeApiUrl'])}/v1/passport/profile/scan/status`,
        init: getArcadeFetchOptions(),
      };
      if (statusCallCount < 8) {
        statusCallCount += 1;
        abortableFetch({
          options,
          onResponse: (status, data) => {
            if (data.status_code === STAMPS_SCAN_STATUS.COMPLETED) {
              resetInterval();
              dispatch({
                type: 'modules/arcade-root/MERGE_VALUES',
                payload: fromJS({
                  stampsScanStatus: data.status_code,
                  showScanBanner: true,
                }),
              });
            }
          },
          onException: (e) => {
            console.log(e, 'ignore error and retry');
          },
          dispatch,
        });
      } else {
        resetInterval();
        dispatch({
          type: 'modules/arcade-root/MERGE_VALUES',
          payload: fromJS({
            stampsScanStatus: STAMPS_SCAN_STATUS.ERROR,
            showScanBanner: true,
          }),
        });
        dispatch(addErrorToReport(new Error('Fins scan timeout'), {
          collectionMethod: 'apiPollStampsScanStatus - Max Retries',
          moduleID: 'arcade-page-wrapper',
          trackingId: options.init.headers['x-amex-tracking-id'],
        }));
      }
    }, 10000);
  }
};
